import { HTTP } from '@/api/http-common'

export default {
  getShippingAllRegionCountry (callback, param) {
    HTTP.get(param.token + '/shipping/country?language=' + param.language + '&member=' + param.member + '&country=' + param.country).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getProvinceList (callback, param) {
    HTTP.get('/province?language=' + param.language).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getDistrictList (callback, param) {
    HTTP.get(param.token + '/shipping/district?language=' + param.language + '&province_id=' + param.province_id).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getSubDistrictList (callback, param) {
    HTTP.get(param.token + '/shipping/subdistrict?language=' + param.language + '&district_id=' + param.district_id).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/shipping/index.js